import { ExecutionBriefWorkOrdersState } from "./execution-brief-work-orders.interface";

export function createExecutionBriefWorkOrdersState(): ExecutionBriefWorkOrdersState {
  return {
    errors: null,
    loading: false,
    results: [],
  };
}
